/**
 * Action types.
 * @module constants/ActionTypes
 */

export const GET_SVG = 'GET_SVG';
